<template>
  <div>
    <div>
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-plus"
        @click="openEditZoneWhiteEntryDialog(true, {})"
        >新增白名单项</el-button
      >
    </div>

    <el-table
      :data="zoneWhiteList"
      border
      size="small"
      style="width: 631px"
      height="450px"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column prop="type" label="类型" align="center" width="100">
      </el-table-column>

      <el-table-column prop="value" label="值" align="center" width="150">
      </el-table-column>

      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip
        align="center"
        width="200"
      >
      </el-table-column>

      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="removeZoneWhiteEntry(scope.row)"
            >删除</el-button
          >
          <el-button
            type="primary"
            round
            size="mini"
            @click="openEditZoneWhiteEntryDialog(false, scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
  data() {
    return {
      zoneWhiteList: [],
      list: [], // 白名单列表里展示的数据
    };
  },

  created() {
    this.loadWhiteList();
  },

  methods: {
    /**
     * 拉取白名单
     */
    async loadWhiteList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getWhiteListEntryForZoneVisit`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.zoneWhiteList = listInResponse;
    },

    /**
     *打开“添加/修改分区白名单”对话框
     */
    openEditZoneWhiteEntryDialog(isCreate, oldData) {
      dialogutil.open("EditZoneWhiteDialog", {
        closedCallback: () => {
          this.loadWhiteList();
        },
        data: { isCreate: isCreate, form: oldData },
      });
    },

    /**
     * 删除分区白名单
     */
    async removeZoneWhiteEntry(entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除白名单{Type:${entry.type}, Value: ${entry.value}}的白名单？`
        );

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/delWhiteListEntryForZoneVisit`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.zoneWhiteList.length; i++) {
          if (this.zoneWhiteList[i].id == entry.id) {
            this.zoneWhiteList.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },
  },
};
</script>